import { createContext, useContext } from "react";
/**
 * Path for the 3D viewer script, depends on your application.
 */
export const CadClickUiControlsScriptUrlContext = createContext("kim-viewer-3d/uicontrols.iife.2.3.0.min.js");
/**
 * Returns path for the 3D viewer script.
 * @returns
 */
export function useCadClickUiControlsScriptUrl() {
    return useContext(CadClickUiControlsScriptUrlContext);
}
export function useCadClickUiControlsTranslationsUrl() {
    const url = useContext(CadClickUiControlsScriptUrlContext);
    const translationsUrl = url.slice(0, url.lastIndexOf("/") + 1) + "translations";
    return translationsUrl;
}
//# sourceMappingURL=CadClickUiControlsScriptUrlContext.js.map